import { z } from 'zod'

export const GetTimeSchema = z.object({
  from: z
    .string()
    .nullish()
    .transform(time => time && time.slice(0, 5)),
  to: z
    .string()
    .nullish()
    .transform(time => time && time.slice(0, 5)),
  type: z
    .enum(['by', 'at', 'between', '24', 'tbc', 'asap'], { message: 'Please select a time type' })
    .default('between'),
})
